var React = require('react');

function IconAreaInline (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"id":"svg_1","d":"m14,0l-12,0c-1.1,0 -2,0.9 -2,2l0,12c0,1.1 0.9,2 2,2l12,0c1.1,0 2,-0.9 2,-2l0,-12c0,-1.1 -0.9,-2 -2,-2zm0,14l-12,0l0,-12l12,0l0,12z","fill":"currentColor","key":0}),React.createElement("line",{"strokeWidth":"1.5","transform":"rotate(0.195376, 8, 8.03846)","strokeLinecap":"undefined","strokeLinejoin":"undefined","id":"svg_3","y2":"3.30848","x2":"12.57813","y1":"12.76844","x1":"3.42187","stroke":"currentColor","fill":"none","key":1})]));
}

IconAreaInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","version":"1.1"};

module.exports = IconAreaInline;

IconAreaInline.default = IconAreaInline;
